import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { pdfSelector } from 'apps/studio/store/selectors/pdf'
import { DesignSettingsPanel } from 'apps/studio/components/settings/global/Base/design'
import { GlobalSettingsPanel, GlobalStandardSettings } from 'apps/studio/components/settings/global/Base/standard'
import { settingInputs } from 'apps/studio/components/settings/inputs'
import { slugify } from 'apps/builder/lib/utils'
import { pdfActions } from 'apps/studio/store/reducers/entities/pdf'
const { updateGlobalStyles } = pdfActions

const GlobalSetting = ({ pdf, config }) => {
  const { label, labelLarge, settingType } = config
  const SettingInput = settingInputs[settingType]
  const settingId = slugify(`${label}-${settingType}`)

  const update = data => updateGlobalStyles(data)
  const data = pdf.styles

  return (
    <SettingInput
      id={settingId}
      styleLevel="global"
      portal={true}
      data={data}
      update={update}
      {...config}
    />
  )
}

export const globalSettingsConfig = [
  GlobalSettingsPanel(GlobalStandardSettings),
  DesignSettingsPanel,
]

// TODO: We might benefit from standardizing the panel markup into it's
// own component now that we can see where the repeated markup occurs
export const GlobalSettings = ({ activePanels }) => {
  const globalSettings = useSelector(pdfSelector)
  const globalSettingsPanels = useMemo(() => globalSettingsConfig, [])

  return globalSettingsPanels.map(panel => {
    const { label, settings } = panel

    if (!activePanels.includes(label)) return null

    return (
      <div
        className="workspace-panel gcds--control-panel"
        key={`global-settings-panel-${label}`}
      >
        <div className="--workspace-panel--header panel--info">
          <div className="--workspace-panel--title panel--title">{label}</div>
        </div>
        <div className="panel--content workspace-panel--section field-settings-panel">
          {settings.map(setting => (
            <GlobalSetting
              key={setting.label}
              config={setting}
              pdf={globalSettings}
            />
          ))}
        </div>
      </div>
    )
  })
}
